import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allQuestions: [],
};

const getters = {
  GET_ALL_QUESTIONS(state) {
    return state.allQuestions;
  },
  GET_QUESTION: (state) => (id) => {
    return state.allQuestions.find((cat) => cat.id === id);
  },
  GET_QUESTIONS_BY_CATEGORY: (state) => (id) => {
    return state.allQuestions.filter((q) => q.category_id === id);
  },
};

const mutations = {
  SET_ALL_QUESTIONS: (state, payload) => (state.allQuestions = payload),

  PUSH_QUESTION: (state, payload) => state.allQuestions.push(payload),

  UPDATE_QUESTION: (state, payload) => {
    const index = state.allQuestions.findIndex((el) => el.id === payload.id);
    state.allQuestions.splice(index, 1, payload);
  },

  DELETE_QUESTION: (state, id) => {
    const index = state.allQuestions.findIndex((el) => el.id === id);
    state.allQuestions.splice(index, 1);
  },
};

const actions = {
  async REGISTER_QUESTION({ commit }, { name, category_id }) {
    try {
      const payload = { name, category_id };
      const response = await PbxHttpClient.post(`/quality/questions`, payload);
      // console.log(response.data)
      //FOR TESTING
      commit("PUSH_QUESTION", response.data.question);
      commit("categories/PUSH_QUESTION", response.data.question, {
        root: true,
      });
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_QUESTIONS({ commit }, id) {
    try {
      const response = await PbxHttpClient.get(
        `/quality/questions/index/${id}`
      );
      commit("SET_ALL_QUESTIONS", response.data.data[0].questions);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_QUESTION({ commit }, { id, name, category_id }) {
    try {
      const payload = { name, id, category_id };
      const response = await PbxHttpClient.put(
        `/quality/questions/${id}`,
        payload
      );
      commit("UPDATE_QUESTION", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_QUESTION({ commit }, id) {
    try {
      const response = await PbxHttpClient.delete(`/quality/questions/${id}`);
      commit("DELETE_QUESTION", id);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
